import { render, staticRenderFns } from "./user-case-allot.vue?vue&type=template&id=3743392b&scoped=true"
import script from "./user-case-allot.vue?vue&type=script&lang=ts"
export * from "./user-case-allot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3743392b",
  null
  
)

export default component.exports